import React, { useCallback, useEffect } from "react";
import { FrameMetadataEditorModalProps } from "../../types/modal";
import { MdOutlineKeyboardCapslock } from "react-icons/md";
import { PiKeyReturnLight } from "react-icons/pi";

export default function FrameMetadataEditorModal(
  props: Readonly<FrameMetadataEditorModalProps>
) {
  // Handle backdrop click
  const handleBackdropClick = useCallback((e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      props.onCancel();
    }
  }, [props]);

  // Handle escape key
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      props.onCancel();
    }
  }, [props]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [handleKeyDown]);

  /**
   * Handle Enter key press & Ctrl + Enter key press
   * Ctrl + Enter - Save the text & add a new line
   * Enter - Save the text
   * @param e - Keyboard event
   * @returns void
   */
  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      if (e.ctrlKey) {
        // Allow new line when Ctrl + Enter is pressed
        e.preventDefault(); // Prevent default behavior of Enter key
        props.onSave(); // Call the save function
      } else {
        return; // Do nothing, let the default behavior occur
      }
    }
  };

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">
            {props.isForDuplicate ? (
              "Set name for new page"
            ) : (
              `Update name of '${props.oldName}'`
            )}
          </h2>
        </div>
        <div className="modal-body">
          <div className="form-wrapper">
            <div className="input-wrapper">
              <label htmlFor="frameName" className="form-label text-start">
                Name
              </label>
              <input
                autoFocus
                type="text"
                name="frame-name"
                className="form-control"
                id="frameName"
                value={props.frameUpdate?.newName || ""}
                onKeyDown={handleInputKeyDown}
                onChange={(e) => props.onStringChange(e.target.value)}
                placeholder="Type a name for new page"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={props.onSave}
            title="Ctrl + Enter to save"
          >
            Save
            <MdOutlineKeyboardCapslock />
            <PiKeyReturnLight />
          </button>
        </div>
      </div>
    </div>
  );
}
